export const FEATURE_FLAGS_API_PATH = '/v3/features';
